import {
  validateConfirmPassword,
  validatePassword
} from '../../helpers/formValidation'
import { ValidateResetPasswordForm } from './typing'

const validateResetPasswordForm = ({
  values,
  errors,
  field
}: ValidateResetPasswordForm): Record<string, string> => {
  let formErrors: Record<string, string> = { ...errors }
  const { password, confirmPassword } = values

  switch (field) {
    case 'password':
      formErrors['password'] = validatePassword(password)
      break
    case 'confirmPassword':
      formErrors['confirmPassword'] = validateConfirmPassword(
        password,
        confirmPassword
      )
      break
    default:
      formErrors['password'] = validatePassword(password)
      formErrors['confirmPassword'] = validateConfirmPassword(
        password,
        confirmPassword
      )
  }

  return formErrors
}

export default validateResetPasswordForm
